import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onError", "onExpired", "onResolved", "theme", "isEmbedded"];
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateRecaptchaToken } from '../store/google-recaptcha/action-creators';
import { getV2SiteKey } from '../store/google-recaptcha/sitekeys';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecaptchaCheckbox = _ref => {
  let {
      onError,
      onExpired,
      onResolved,
      theme = 'light',
      isEmbedded
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const recaptcha = window.grecaptcha;
  const verifyCallback = useCallback((token, googleRecaptchasitekey) => {
    dispatch(updateRecaptchaToken(token, googleRecaptchasitekey));
    onResolved(token);
  }, [dispatch, onResolved]);
  const expiredCallback = useCallback(() => {
    onExpired();
    recaptcha.enterprise.reset();
  }, [onExpired, recaptcha]);
  const errorCallback = useCallback(error => {
    onError(error);
  }, [onError]);
  const [widgetId, setWidgetId] = useState(null);
  useEffect(() => {
    if (!recaptcha || !recaptcha.enterprise) {
      errorCallback(`The recaptcha is not available or not loaded`);
      return;
    }
    const recaptchaSiteKey = getV2SiteKey();
    recaptcha.enterprise.ready(() => {
      const canRenderRecaptcha = widgetId === null && containerRef.current && recaptcha.enterprise.render;
      if (canRenderRecaptcha) {
        setWidgetId(recaptcha.enterprise.render(containerRef.current, {
          sitekey: recaptchaSiteKey,
          theme,
          size: isEmbedded ? 'compact' : 'normal',
          callback: token => verifyCallback(token, recaptchaSiteKey),
          'expired-callback': expiredCallback,
          'error-callback': errorCallback
        }));
      }
    });
  }, [widgetId, errorCallback, expiredCallback, verifyCallback, theme, recaptcha, isEmbedded]);
  return /*#__PURE__*/_jsx("div", Object.assign({
    ref: containerRef
  }, props));
};